// import React, { useState, useEffect } from "react";
// import { functions } from "../firebase/firebase";
// import { httpsCallable } from "firebase/functions";
// import StockDetailsPage from "./StockDetailsPage";

// const StockDataPage = () => {
//   const [stocks, setStocks] = useState([]);
//   const [filteredStocks, setFilteredStocks] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedStock, setSelectedStock] = useState(null);
//   useEffect(() => {
//     const fetchStockData = async () => {
//       setLoading(true);

//       const getAllStocks = httpsCallable(functions, "getAllStocks");
//       try {
//         // Fetch stock data using Firebase Callable Function
//         const response = await getAllStocks();
//         const stockData = response.data; // Access data from the response

//         console.log("Fetched stock data:", stockData);
//         setStocks(stockData);
//         setFilteredStocks(stockData); // Initialize filtered stocks
//       } catch (err) {
//         setError(err.message);
//         console.error("Error occurred:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchStockData();
//   }, []);

//   useEffect(() => {
//     // Search filtering
//     const filtered = stocks.filter((stock) => {
//       return (
//         stock.Company.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         stock.Symbol.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         (stock.AnalysisStatus &&
//           stock.AnalysisStatus.toLowerCase().includes(searchTerm.toLowerCase()))
//       );
//     });
//     setFilteredStocks(filtered);
//   }, [searchTerm, stocks]);

//   const handleSort = (key) => {
//     let direction = "asc";
//     if (sortConfig.key === key && sortConfig.direction === "asc") {
//       direction = "desc";
//     }
//     setSortConfig({ key, direction });

//     const sortedStocks = [...filteredStocks].sort((a, b) => {
//       if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
//       if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
//       return 0;
//     });
//     setFilteredStocks(sortedStocks);
//   };

//   const getDisplayValue = (value) => (value == null ? 0 : value); // Helper function to handle null values

//   if (loading)
//     return (
//       <div className=" h-[100vh] flex justify-center items-center">
//         Loading...
//       </div>
//     );
//   if (error) return <div>Error: {error}</div>;

//   if (selectedStock) {
//     return (
//       <StockDetailsPage
//         stock={selectedStock}
//         goBack={() => setSelectedStock(null)}
//       />
//     );
//   }

//   return (
//     <div className="  min-w-full flex items-center flex-col ">
//       <div className=" w-full justify-start ">
//         <input
//           type="text"
//           placeholder="Search by company name, symbol, or analysis status... "
//           className="border mb-4 p-2  ml-5 mt-5  "
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//       </div>

//       <div className="w-[97vw] overflow-x-auto mx-4">
//         <table className="table-auto w-full border-collapse border border-gray-300">
//           <thead>
//             <tr className="bg-gray-200 text-left">
//               <th
//                 className="border border-gray-300 px-4 cursor-pointer text-sm"
//                 onClick={() => handleSort("Id")}
//               >
//                 Id
//               </th>
//               <th
//                 className="border border-gray-300 px-4 cursor-pointer text-sm"
//                 onClick={() => handleSort("Symbol")}
//               >
//                 Symbol
//               </th>
//               <th
//                 className="border border-gray-300 px-4 cursor-pointer text-sm"
//                 onClick={() => handleSort("Company")}
//               >
//                 Company
//               </th>
//               <th
//                 className="border border-gray-300 px-4 cursor-pointer text-sm"
//                 onClick={() => handleSort("AnalysisStatus")}
//               >
//                 Analysis Status
//               </th>
//               <th
//                 className="border border-gray-300 px-4 cursor-pointer text-sm"
//                 onClick={() => handleSort("AnalyzedOn")}
//               >
//                 Analyzed On
//               </th>
//               <th
//                 className="border border-gray-300 px-4 cursor-pointer text-sm"
//                 onClick={() => handleSort("DividendPotential")}
//               >
//                 Dividend Potential
//               </th>
//               <th
//                 className="border border-gray-300 px-4 cursor-pointer text-sm"
//                 onClick={() => handleSort("DiscountedValue")}
//               >
//                 Discounted Value
//               </th>
//               <th
//                 className="border border-gray-300 px-4 cursor-pointer text-sm"
//                 onClick={() => handleSort("IntrinsicValueUpdatedOn")}
//               >
//                 Intrinsic Value Updated On
//               </th>
//               <th
//                 className="border border-gray-300 px-4 cursor-pointer text-sm"
//                 onClick={() => handleSort("year")}
//               >
//                 Year
//               </th>
//               <th
//                 className="border border-gray-300 px-4 cursor-pointer text-sm"
//                 onClick={() => handleSort("CurrentPrice")}
//               >
//                 Current Price
//               </th>
//               <th
//                 className="border border-gray-300 px-4 cursor-pointer text-sm"
//                 onClick={() => handleSort("PriceToEarnings")}
//               >
//                 Price/Earnings Ratio
//               </th>
//               <th
//                 className="border border-gray-300 px-4 cursor-pointer text-sm"
//                 onClick={() => handleSort("ProfitMargin")}
//               >
//                 Profit Margin
//               </th>
//               <th
//                 className="border border-gray-300 px-4 cursor-pointer text-sm"
//                 onClick={() => handleSort("YearsToClearDebt")}
//               >
//                 Years to Clear Debt
//               </th>
//               <th
//                 className="border border-gray-300 px-4 cursor-pointer text-sm"
//                 onClick={() => handleSort("DividendYield")}
//               >
//                 Dividend Yield
//               </th>
//               <th
//                 className="border border-gray-300 px-4 cursor-pointer text-sm"
//                 onClick={() => handleSort("BookValueToPriceRatio")}
//               >
//                 BV/Price Ratio
//               </th>
//               <th
//                 className="border border-gray-300 px-4 cursor-pointer text-sm"
//                 onClick={() => handleSort("AssetToDebtRatio")}
//               >
//                 Asset/Debt Ratio
//               </th>
//               <th
//                 className="border border-gray-300 px-4 cursor-pointer text-sm"
//                 onClick={() => handleSort("WorkingCaptoPrice")}
//               >
//                 WorkingCap to Price
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredStocks.length > 0 ? (
//               filteredStocks.map((stock, index) => (
//                 <tr
//                   key={stock.Id}
//                   className={index % 2 === 0 ? "bg-white" : "bg-gray-100"}
//                 >
//                   <td className="border border-gray-300 px-4">
//                     {getDisplayValue(stock.Id)}
//                   </td>
//                   <td
//                     className="border border-gray-300 px-4 text-blue-500 cursor-pointer"
//                     onClick={() => setSelectedStock(stock)}
//                   >
//                     {getDisplayValue(stock.Symbol)}
//                   </td>
//                   <td className="border border-gray-300 px-4">
//                     {getDisplayValue(stock.Company)}
//                   </td>
//                   <td className="border border-gray-300 px-4">
//                     {getDisplayValue(stock.AnalysisStatus)}
//                   </td>
//                   <td className="border border-gray-300 px-4">
//                     {getDisplayValue(stock.AnalyzedOn)}
//                   </td>
//                   <td className="border border-gray-300 px-4">
//                     {getDisplayValue(stock.DividendPotential)}
//                   </td>
//                   <td className="border border-gray-300 px-4">
//                     {getDisplayValue(stock.DiscountedValue).toFixed(2)}
//                   </td>
//                   <td className="border border-gray-300 px-4">
//                     {getDisplayValue(stock.IntrinsicValueUpdatedOn)}
//                   </td>
//                   <td className="border border-gray-300 px-4">
//                     {getDisplayValue(stock.year)}
//                   </td>
//                   <td className="border border-gray-300 px-4">
//                     {getDisplayValue(stock.CurrentPrice).toFixed(2)}
//                   </td>
//                   <td className="border border-gray-300 px-4">
//                     {getDisplayValue(stock.PriceToEarnings).toFixed(2)}
//                   </td>
//                   <td className="border border-gray-300 px-4">
//                     {getDisplayValue(stock.ProfitMargin).toFixed(2)}
//                   </td>
//                   <td className="border border-gray-300 px-4">
//                     {getDisplayValue(stock.YearsToClearDebt).toFixed(2)}
//                   </td>
//                   <td className="border border-gray-300 px-4">
//                     {getDisplayValue(stock.DividendYield).toFixed(2)}
//                   </td>
//                   <td className="border border-gray-300 px-4">
//                     {getDisplayValue(stock.BookValueToPriceRatio).toFixed(2)}
//                   </td>
//                   <td className="border border-gray-300 px-4">
//                     {getDisplayValue(stock.AssetToDebtRatio).toFixed(2)}
//                   </td>
//                   <td className="border border-gray-300 px-4">
//                     {getDisplayValue(stock.WorkingCaptoPrice).toFixed(2)}
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="17" className="text-center px-4">
//                   No data available.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

 // export default StockDataPage;



import React, { useState, useEffect } from "react";
import { functions } from "../firebase/firebase";
import { httpsCallable } from "firebase/functions";
import SearchBar from "../components/SearchBar";
import FileUpload from "../components/FileUpload";
import StockTable from "../components/StockTable";
import {auth } from "../firebase/firebase";
import LogoutButton from "../components/LogoutButton";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const StockDataPage = () => {

  const [stocks, setStocks] = useState([]);
  const [filteredStocks, setFilteredStocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: "Id", direction: "asc" });
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStock, setSelectedStock] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [fileUrl, setFileUrl] = useState("");

  useEffect(() => {
    const fetchStockData = async () => {
      setLoading(true);

      const generateStockDataFile = httpsCallable(
        functions,
        "generateStockDataFile"
      );
      try {
        // Get the current user from Firebase Auth
        const user = auth.currentUser;
        if (!user) {
          throw new Error("User is not authenticated.");
        }

        // Get the ID token of the authenticated user
        const idToken = await user.getIdToken();

        console.log(
          "idToken inside StockDataPage ------------------------------------>",
          idToken
        );

        // Call the Cloud Function to get the file URL
        const data = await generateStockDataFile(
          {},
          {
            headers: {
              Authorization: `Bearer ${idToken}`, // Include the token here
            },
          }
        );

        // console.log("response--------------------------", data.data);

        const stockData = data.data;

        // Format the date fields
        const formattedData = stockData.map((stock) => ({
          ...stock,
          // AnalyzedOn: formatDate(stock.AnalyzedOn),
          // IntrinsicValueUpdatedOn: formatDate(stock.IntrinsicValueUpdatedOn),
        }));
        setStocks(formattedData);
        setFilteredStocks(formattedData);
        handleSort("Id");
      } catch (err) {
        console.log("error ----------------", err);

        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchStockData(); // Call the function to fetch data
  }, []);

  // const formatDate = (dateString) => {
  //   if (!dateString) return ""; // Handle null or undefined
  //   const options = { day: "numeric", month: "short", year: "numeric" };
  //   const dateParts = dateString.split("/");

  //   if (dateParts.length !== 3) return "Invalid Date"; // Check for valid date format

  //   const date = new Date(dateParts.reverse().join("-")); // Convert 'DD/MM/YYYY' to 'YYYY-MM-DD'
  //   return date.toLocaleDateString("en-GB", options).replace(/ /g, " "); // Format the date without line breaks
  // };

  useEffect(() => {
    const filtered = stocks.filter((stock) => {
      return (
        stock.Company.toLowerCase().includes(searchTerm.toLowerCase()) ||
        stock.Symbol.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (stock.AnalysisStatus &&
          stock.AnalysisStatus.toLowerCase().includes(searchTerm.toLowerCase()))
      );
    });
    setFilteredStocks(filtered);
  }, [searchTerm, stocks]);

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sortedStocks = [...filteredStocks].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });
    setFilteredStocks(sortedStocks);
  };

  const openStockDetailPageInNewTab = (stockId) => {
    if (!stockId) {
      console.error("Stock Id is undefined");
      return;
    }
    window.open(`/stockdetailspage/${stockId}`, "_blank");
  };

  // Trigger toast notification for upload progress
  useEffect(() => {
    if (uploadProgress > 0 && uploadProgress < 100) {
      toast.info(`Upload Progress: ${uploadProgress}%`, { autoClose: false });
    } else if (uploadProgress === 100) {
      toast.dismiss();
      toast.success("Upload complete!");
    }
  }, [uploadProgress]);

  if (loading)
    return (
      <div className="h-[100vh] flex justify-center items-center">
        Loading...
      </div>
    );
  if (error) return <div>Error: {error}</div>;

  if (selectedStock) {
    openStockDetailPageInNewTab(selectedStock.Id);
    setSelectedStock(null);
  }

  return (
    <div className="min-w-full flex  flex-col space-y-4 mt-1">
      <div className="flex items-start justify-between space-x-4 mr-7 mb-0">
        <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        <FileUpload
          setUploadProgress={setUploadProgress}
          setFileUrl={setFileUrl}
        />
        <LogoutButton />
      </div>
      {/* {uploadProgress > 0 && <p>Upload Progress: {uploadProgress}%</p>} */}
      {fileUrl && (
        <p>
          File uploaded to: <a href={fileUrl}>{fileUrl}</a>
        </p>
      )}
      <div className="mt-0">
        <StockTable
          stocks={filteredStocks}
          handleSort={handleSort}
          sortConfig={sortConfig}
          setSelectedStock={setSelectedStock}
        />
      </div>
    </div>
  );
};

export default StockDataPage;
